var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "error-messages": _vm.$errorMessages(_vm.$v.localPersonalName.lastName)
    },
    on: {
      "input": _vm.setPersonalName,
      "blur": function blur($event) {
        return _vm.$v.localPersonalName.lastName.$touch();
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Фамилия")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.localPersonalName.lastName,
      callback: function callback($$v) {
        _vm.$set(_vm.localPersonalName, "lastName", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "localPersonalName.lastName"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "error-messages": _vm.$errorMessages(_vm.$v.localPersonalName.lastNameGenitive)
    },
    on: {
      "input": _vm.setPersonalName,
      "blur": function blur($event) {
        return _vm.$v.localPersonalName.lastNameGenitive.$touch();
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Фамилия в Родительном падеже")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.localPersonalName.lastNameGenitive,
      callback: function callback($$v) {
        _vm.$set(_vm.localPersonalName, "lastNameGenitive", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "localPersonalName.lastNameGenitive"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "error-messages": _vm.$errorMessages(_vm.$v.localPersonalName.firstName)
    },
    on: {
      "input": _vm.setPersonalName,
      "blur": function blur($event) {
        return _vm.$v.localPersonalName.firstName.$touch();
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Имя")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.localPersonalName.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.localPersonalName, "firstName", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "localPersonalName.firstName"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "error-messages": _vm.$errorMessages(_vm.$v.localPersonalName.firstNameGenitive)
    },
    on: {
      "input": _vm.setPersonalName,
      "blur": function blur($event) {
        return _vm.$v.localPersonalName.firstNameGenitive.$touch();
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Имя в Родительном падеже")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.localPersonalName.firstNameGenitive,
      callback: function callback($$v) {
        _vm.$set(_vm.localPersonalName, "firstNameGenitive", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "localPersonalName.firstNameGenitive"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Отчество",
      "placeholder": "Введите данные",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "error-messages": _vm.$errorMessages(_vm.$v.localPersonalName.middleName)
    },
    on: {
      "input": _vm.setPersonalName,
      "blur": function blur($event) {
        return _vm.$v.localPersonalName.middleName.$touch();
      }
    },
    model: {
      value: _vm.localPersonalName.middleName,
      callback: function callback($$v) {
        _vm.$set(_vm.localPersonalName, "middleName", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "localPersonalName.middleName"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Отчество в Родительном падеже",
      "placeholder": "Введите данные",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "error-messages": _vm.$errorMessages(_vm.$v.localPersonalName.middleNameGenitive)
    },
    on: {
      "input": _vm.setPersonalName,
      "blur": function blur($event) {
        return _vm.$v.localPersonalName.middleNameGenitive.$touch();
      }
    },
    model: {
      value: _vm.localPersonalName.middleNameGenitive,
      callback: function callback($$v) {
        _vm.$set(_vm.localPersonalName, "middleNameGenitive", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "localPersonalName.middleNameGenitive"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }